import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import {
	ImagePlaceholderDefintion as definition,
	ImagePlaceholderService as impl,
	IImagePlaceholderDefintion,
	ImagePlaceholderPageConfig,
	IImagePlaceholderConfig,
} from '@wix/image-placeholder'

export const imagePlaceholderService = withDependencies(
	[named(PageFeatureConfigSymbol, name)],
	(
		pageFeatureConfig: ImagePlaceholderPageConfig
	): ServiceProvider<IImagePlaceholderDefintion, (opts: ServiceFactoryOpts<IImagePlaceholderConfig>) => any> => {
		const { isSEOBot, staticMediaUrl } = pageFeatureConfig
		return {
			definition,
			impl,
			config: { isSEOBot, baseMediaUrl: staticMediaUrl },
		}
	}
)
